import React, { Children, cloneElement, useState } from 'react';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
`;

/**
 * DialogTrigger accepts as input at least 2 children node.
 * The first is the trigger, the second is the element showed.
 * @param {*} children
 */
const DialogTrigger = ({ children }) => {
    const [show, setShow] = useState(false);

    const [first, second] = Children.toArray(children);

    const trigger = cloneElement(first, {
        onClick: () => {
            setShow((oldValue) => !oldValue);
            if (first.props.onClick) {
                first.props.onClick();
            }
        },
    });

    return (
        <Container
            onMouseOver={() => {
                if (!isMobile) {
                    setShow(true);
                }
            }}
            onMouseLeave={() => {
                setShow(false);
            }}
        >
            {trigger}
            {show && second}
        </Container>
    );
};

DialogTrigger.propTypes = {
    children: PropTypes.node,
};

export default DialogTrigger;
